import Vue                  from 'vue';
import VueRouter            from 'vue-router';
import Common               from '@/utils/common.js';
import HomeViewPc           from '../views/pc/HomeView.vue';
import HomeNewViewPc        from '../views/pc/HomeNewView.vue';
import HomeViewMobile       from '../views/mobile/HomeView.vue';
import AllGamesViewPc       from '../views/pc/AllGamesView.vue';
import AllGamesViewMobile   from '../views/mobile/AllGamesView.vue';
import GameDetailViewPc     from '../views/pc/GameDetailView.vue';
import GameDetailViewMobile from '../views/mobile/GameDetailView.vue';
import ServiceAgreementPc   from '../views/pc/ServiceAgreement.vue';
import PrivacyPolicyPc      from '../views/pc/PrivacyPolicy.vue';

Vue.use(VueRouter);

/**
 * 路由规则
 */
const routes = [
	{
		path     : '/',
		name     : 'home',
		component: determineHomeViewComponent()// 使用动态路由
	},
	{
		path     : '/aboutus',
		name     : 'about',
		/**
		 * route level code-splitting
		 * this generates a separate chunk (about.[hash].js) for this route
		 * which is lazy-loaded when the route is visited.
		 */
		component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
	},
	{
		path     : '/allgames',
		name     : 'allgames',
		component: determineAllGamesViewComponent()// 使用动态路由
	},
	{
		path     : '/gamedetail/:game_id/:key',
		name     : 'gamedetail',
		component: determineGameDetailViewComponent()// 使用动态路由
	},
	{
		path     : '/download',
		name     : 'DownloadSoofun',
		component: () => import('@/views/mobile/DownloadSoofun.vue'),
		meta     : {
			title: 'Soofun下载'
		}
	},
	{
		path     : '/service_agreement',
		name     : 'sa',
		component: determineSaViewComponent()// 使用动态路由
	},
	{
		path     : '/privacy_policy',
		name     : 'pp',
		component: determinePpViewComponent()// 使用动态路由
	}
];

/**
 * 路由实例
 */
const router = new VueRouter({
	routes
});

/**
 * 检测设备类型并返回对应的首页视图组件
 */
function determineHomeViewComponent(){
	// 等待异步操作完成
	if(Common.isMobile())
	{
		// console.log('=== router__index__determineHomeViewComponent__Common__isMobile >>>', 1);
		// return HomeViewPc;
		return HomeViewMobile;
	}
	else
	{
		// console.log('=== router__index__determineHomeViewComponent__Common__isMobile >>>', 0);
		return HomeViewPc;
		// return HomeNewViewPc;
	}
}

function determineAllGamesViewComponent(){
	// 等待异步操作完成
	if(Common.isMobile())
	{
		return AllGamesViewMobile;
	}
	else
	{
		return AllGamesViewPc;
	}
}

function determineGameDetailViewComponent(){
	// 等待异步操作完成
	if(Common.isMobile())
	{
		return GameDetailViewMobile;
	}
	else
	{
		return GameDetailViewPc;
	}
}

function determineSaViewComponent() {
	return ServiceAgreementPc;
}
function determinePpViewComponent() {
	return PrivacyPolicyPc;
}

// 获取原型对象push函数
const originalPush    = VueRouter.prototype.push;
// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;
// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
	return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
	return originalReplace.call(this, location).catch(err => err)
}

// 添加导航守卫
router.beforeEach((to, from, next) => {
	// console.log('=== router__index__beforeEach__to >>>', to);
	// console.log('=== router__index__beforeEach_from >>>', from);

	/* if(to.name === from.name && to.name === 'gamedetail')
	{
		// 重新加载页面
		console.log('=== router__index__beforeEach__to__gamedetail >>>', 1);
		window.location.reload();
	}
	else
	{
		next();
	} */
	
	// 检查是否重复导航到相同的路由
	/* if(to.path === from.path)
	{
		// 避免重复导航，可以不执行导航
		return;
	} */

	next();
});

export default router;
